import React from 'react';
import './Avatar.css';

interface AvatarProps {
  photoUrl?: string | null;
  name?: string;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ photoUrl, name, size = 'medium', className = '' }) => {
  const getInitials = (name?: string) => {
    if (!name) return '?';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  // If photoUrl is already a complete URL (starts with http/https), use it directly
  // Otherwise, prepend the API URL for legacy local photos
  const imageUrl = photoUrl
    ? (photoUrl.startsWith('http://') || photoUrl.startsWith('https://'))
      ? photoUrl
      : `${process.env.REACT_APP_API_URL?.replace('/api', '')}${photoUrl}`
    : null;

  return (
    <div className={`avatar avatar-${size} ${className}`}>
      {imageUrl ? (
        <img src={imageUrl} alt={name || 'User'} className="avatar-image" />
      ) : (
        <div className="avatar-placeholder">
          {getInitials(name)}
        </div>
      )}
    </div>
  );
};

export default Avatar;
